import { render } from "./EmptyPerks.vue?vue&type=template&id=23aa4ef5&ts=true"
import script from "./EmptyPerks.vue?vue&type=script&lang=ts"
export * from "./EmptyPerks.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__